import React, { useEffect, useMemo } from 'react'
import PropTypes from 'prop-types'
import { isEmpty } from 'lodash'

import StaffList from './StaffList'
import { searchData } from '../../utils/searchData'

const SuitesStaff = ({
  attendants,
  attendantSettings,
  attendantStatusFilterValue,
  currentVenueUuid,
  fetchEmployeeRoles,
  getEmployeeRole,
  history,
  loadAttendantSettings,
  loadSuitesStaff,
  searchSuitesStaffValue,
}) => {
  const searchedData = useMemo(() => searchData(searchSuitesStaffValue, attendants), [attendants, searchSuitesStaffValue])

  useEffect(() => {
    if (!isEmpty(currentVenueUuid)) {
      loadSuitesStaff(currentVenueUuid)
    }
  }, [loadSuitesStaff, currentVenueUuid])

  useEffect(() => {
    if (!isEmpty(currentVenueUuid)) {
      loadAttendantSettings(currentVenueUuid)
    }
  }, [loadAttendantSettings, currentVenueUuid])

  useEffect(() => {
    fetchEmployeeRoles(currentVenueUuid)
  }, [currentVenueUuid, fetchEmployeeRoles])

  return (
    <div className="attendants">
      <div className="header">
        <ul className="header__menu">
          <li>Name</li>
          <li>Role</li>
          <li>Menus</li>
        </ul>
      </div>
      <StaffList
        attendantSettings={attendantSettings}
        attendantStatusFilterValue={attendantStatusFilterValue}
        data={searchedData}
        getEmployeeRole={getEmployeeRole}
        history={history}
        searchSuitesStaffValue={searchSuitesStaffValue}
      />
    </div>
  )
}

SuitesStaff.defaultProps = {
  attendants: [],
  attendantSettings: {},
  currentVenueUuid: '',
  searchSuitesStaffValue: '',
  getEmployeeRole: () => {},
  loadAttendantSettings: () => {},
  loadSuitesStaff: () => {},
}

SuitesStaff.propTypes = {
  attendants: PropTypes.array,
  attendantSettings: PropTypes.object,
  currentVenueUuid: PropTypes.string,
  getEmployeeRole: PropTypes.func,
  loadAttendantSettings: PropTypes.func,
  loadSuitesStaff: PropTypes.func,
  searchSuitesStaffValue: PropTypes.string,
}

export default SuitesStaff
